import React from "react";
import Box from "./Box";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import { CheckCircle2 } from "lucide-react";
function ToolsPages() {
    const benefits = [
   "Become well-informed before making loans and investment decisions",
"Collaboratively plan expenses and repayments in all transparency",
"Very accurately analyze and assess returns and financial growth ",
"	Weigh different financial options before settling on the very best one",
"Minimize manual calculation human errors during approximation exercises"
  ];
  const points = [
    "Translate complex financial concepts into usable numbers",
    "Help users to appreciate how interest rates, tenures, and contributions pertain to issuances",
    "Help build a practical, personalized financial plan",
    "Assess financial progress and modify plans with changing priorities in life",
  ];
  const boxesData = [
    {
      imgSrc: "../assets/sip.jpeg",
      title: "SIP Calculator        ",
      description:
        "Plan your investments with our SIP calculator! See how much your savings can grow over time.   ",
      link: "/financial-tools-calculators/sip-calculator",
    },
    {
      imgSrc: "../assets/lumpsum.jpeg",
      title: "Lumpsum Calculator        ",
      description:
        " Plan your lump sum investment! See how much you can achieve with a one-time investment.   ",
      link: "/financial-tools-calculators/lumpsum-calculator",
    },
    {
      imgSrc: "../assets/swp.jpeg",
      title: "SWP Calculator        ",
      description:
        "Plan your income stream! Use our SWP calculator to see how much you will have left after withdrawals.        ",
      link: "/financial-tools-calculators/swp-calculator",
    },
    {
      imgSrc: "../assets/mutual.jpeg",
      title: "Mutual Fund Calculator        ",
      description:
        "Mutual Fund Returns Made Easy! Calculate your gains with our investment calculator.",
      link: "/financial-tools-calculators/mutual-fund-calculator",
    },
    {
      imgSrc: "../assets/sukanya.jpeg",
      title: "Sukanya Samriddhi Yojana Calculator        ",
      description:
        "Estimate your Sukanya Samriddhi Yojana returns with our calculator based on your contributions.        ",
      link: "/financial-tools-calculators/sukanya-samriddhi-yojana-calculator        ",
    },
    {
      imgSrc: "../assets/ppf.jpeg",
      title: "PPF Calculator        ",
      description:
        "Estimate your PPF maturity amount! Use PPF calculator to see how much your PPF account could grow.   ",
      link: "/financial-tools-calculators/ppf-calculator ",
    },
    {
      imgSrc: "../assets/epf.jpeg",
      title: "EPF Calculator        ",
      description:
        "Estimate your EPF corpus! Use the EPF calculator to get a sense of how much your EPF will accumulate.        ",
      link: "/financial-tools-calculators/pf-epf-calculator ",
    },
    {
      imgSrc: "../assets/fd.jpeg",
      title: "FD Calculator",
      description:
        "Stress-free FD returns! Our calculator helps you discover your fixed deposit earnings with ease.        ",
      link: "/financial-tools-calculators/fd-calculator ",
    },
    {
      imgSrc: "../assets/rd.jpeg",
      title: "RD Calculator",
      description:
        "RD growth at your fingertips! Calculate your recurring deposit returns with just a few clicks.        ",
      link: "/financial-tools-calculators/rd-calculator    ",
    },
    {
      imgSrc: "../assets/nps.jpeg",
      title: "NPS Calculator        ",
      description:
        "Monitor your NPS performance! Use our tool to gain insights into your NPS returns.        ",
      link: "/financial-tools-calculators/nps-calculator        ",
    },
    {
      imgSrc: "../assets/hra.jpeg",
      title: "HRA Calculator        ",
      description:
        "Plan your housing expenses! Our HRA helps you understand how much tax benefit you might receive on your rent.        ",
      link: "/financial-tools-calculators/hra-exemption-calculator ",
    },
    {
      imgSrc: "../assets/pention.jpeg",
      title: "Retirement Calculator       ",
      description:
        "Plan your dream retirement! See how much you might need to save for a comfortable lifestyle after you work.        ",
      link: "/financial-tools-calculators/retirement-planning-calculator",
    },
    {
      imgSrc: "../assets/emi.jpeg",
      title: "EMI Calculator       ",
      description:
        "Plan your loan payments! See your estimated monthly EMI for car, personal, and education loans etc.        ",
      link: "/financial-tools-calculators/emi-calculator",
    },
    {
      imgSrc: "../assets/carcalculator.jpeg",
      title: "Car Loan EMI Calculator",
      description:
        "Estimate your monthly car loan payment! Use our calculator to see what your EMI might be.        ",
      link: "/financial-tools-calculators/car-loan-emi-calculator",
    },
    {
      imgSrc: "../assets/homecalculator.jpeg",
      title: "Home Loan EMI Calculator ",
      description:
        "Estimate your monthly home loan payment! See how much your EMIs could be.        ",
      link: "/financial-tools-calculators/home-loan-emi-calculator",
    },
    {
      imgSrc: "../assets/interest.jpeg",
      title: "  Simple Interest Calculator       ",
      description:
        "Track your earnings and interest! See how much your investments grow and how much you pay on loans.        ",
      link: "/financial-tools-calculators/simple-interest-calculator",
    },
    {
      imgSrc: "../assets/compound.jpeg",
      title: "  Compound Interest Calculator       ",
      description:
        "Grow your money faster! See the power of compound interest with our easy-to-use calculator.        ",
      link: "/financial-tools-calculators/compound-interest-calculator        ",
    },
    {
      imgSrc: "../assets/nsc.jpeg",
      title: "  NSC Calculator       ",
      description:
        "Plan your savings growth! See how much your National Savings Certificate investment can accumulate over time.        ",
      link: "/financial-tools-calculators/nsc-calculator",
    },
    {
      imgSrc: "../assets/setsip.jpeg",
      title: " Step Up SIP Calculator      ",
      description:
        "Boost your SIP returns! See how increasing your investment amount annually can grow your savings significantly.        ",
      link: "/financial-tools-calculators/step-up-sip-calculator",
    },
    {
      imgSrc: "../assets/tax.jpeg",
      title: "Income Tax Calculator",
      description:
        "Estimate your tax burden in a flash! Use our calculator to simplify your tax calculations.  ",
      link: "/financial-tools-calculators/income-tax-calculator",
    },
    {
      imgSrc: "../assets/gratuity.jpeg",
      title: "    Gratuity Calculator      ",
      description:
        "Estimate your retirement gratuity! Learn how much you might receive based on your salary and service.        ",
      link: "/financial-tools-calculators/gratuity-calculator",
    },
    {
      imgSrc: "../assets/pention.jpeg",
      title: "APY Calculator",
      description:
        " Use our calculator to estimate your monthly contribution for your target retirement pension.        ",
      link: "/financial-tools-calculators/apy-calculator",
    },
    {
      imgSrc: "../assets/cagr.jpeg",
      title: " CAGR Calculator      ",
      description:
        "See how your money grows over time! Use our easy-to-use CAGR calculator.        ",
      link: "/financial-tools-calculators/cagr-calculator",
    },
    {
      imgSrc: "../assets/tax2.jpeg",
      title: "GST Calculator      ",
      description:
        "GST made easy! Calculate your payable GST amount quickly and effortlessly. ",
      link: "/financial-tools-calculators/gst-calculator",
    },
    {
      imgSrc: "../assets/flat.jpeg",
      title: " Flat Reducing Rate Calculator     ",
      description:
        "Plan your loan payments wisely! Our calculator helps you compare EMIs under flat and reducing interest rates.        ",
      link: "/financial-tools-calculators/flat-vs-reducing-rate-calculator",
    },
    // { imgSrc: 'https://cdn3d.iconscout.com/3d/premium/thumb/calculator-4086297-3379639.png?f=webp', title: ' Margin     ', description: 'Plan your trades effectively! See how margin can impact your buying power for delivery and intraday stock orders.        ', link: '/financial-tools-calculators/equity-margin-calculator' },
    {
      imgSrc: "../assets/inflation.jpeg",
      title: " Inflation Calculator    ",
      description:
        "Factor in inflation! Our calculator helps you understand the purchasing power of money across different years.   ",
      link: "/financial-tools-calculators/inflation-calculator",
    },
    {
      imgSrc: "../assets/salary.jpeg",
      title: "Salary Calculator",
      description:
        "Know what hits your bank! Estimate your take-home pay after taxes and deductions.        ",
      link: "/financial-tools-calculators/salary-calculator",
    },
    {
      imgSrc: "../assets/brokerage.jpeg",
      title: " Brokerage Calculator    ",
      description:
        "Trade informed! Use our calculator to understand the fees associated with your stock orders.        ",
      link: "/financial-tools-calculators/brokerage-calculator",
    },
    {
      imgSrc: "../assets/1new.png",
      title: "TDS Calculator    ",
      description:
        "Know your TDS liability! Use our tool to get an idea of your potential TDS deductions.        ",
      link: "/financial-tools-calculators/tds-calculator",
    },
    {
      imgSrc: "../assets/2new.png",
      title: "Term Life Insurance Calculator   ",
      description:
        "Secure your family’s future! Estimate how much coverage you need and what it’ll cost.       ",
      link: "/financial-tools-calculators/term-insurance-calculator",
    },
    {
      imgSrc: "../assets/3new.png",
      title: "Travel Insurance Calculator  ",
      description:
        " Travel worry-free! Get a quick estimate on your travel insurance costs and coverage.       ",
      link: "/financial-tools-calculators/travel-insurance-calculator",
    },
    {
      imgSrc: "../assets/4new.png",
      title: "Car Insurance Calculator  ",
      description:
        " Drive smart! Calculate your premium and coverage for car insurance instantly.       ",
      link: "/financial-tools-calculators/car-insurance-calculator",
    },
    {
      imgSrc: "../assets/5new.png",
      title: "Bike Insurance Calculator    ",
      description:
        " Ride insured! Get a quick snapshot of your bike insurance premium and benefits.      ",
      link: "/financial-tools-calculators/bike-insurance-calculator",
    },
    {
      imgSrc: "../assets/6new.png",
      title: "Health Insurance Calculator    ",
      description:
        " Protect your health! Estimate your premium and coverage in just a few clicks.    ",
      link: "/financial-tools-calculators/health-insurance-calculator",
    },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "HDFC SIP Calculator   ",
    //   description:
    //     " Invest confidently! See how your HDFC SIP can grow over time.     ",
    //   link: "/financial-tools-calculators/hdfc-sip-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "ICICI SIP Calculator  ",
    //   description:
    //     "Plan your future! Calculate returns on your ICICI SIP investments with ease.       ",
    //   link: "/financial-tools-calculators/icici-sip-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "AXIS SIP Calculator    ",
    //   description:
    //     " Build wealth smartly! Get a quick view of your AXIS SIP potential returns.     ",
    //   link: "/financial-tools-calculators/axis-sip-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Kotak SIP Calculator    ",
    //   description:
    //     " Grow your money! Estimate your Kotak SIP earnings over the long term.       ",
    //   link: "/financial-tools-calculators/kotak-sip-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Canara SIP Calculator   ",
    //   description:
    //     " Invest with clarity! Calculate the growth of your Canara SIP investment.       ",
    //   link: "/financial-tools-calculators/canara-bank-sip-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "SBI SIP Calculator   ",
    //   description:
    //     " Start small, dream big! Know how your SBI SIP can shape your financial goals.     ",
    //   link: "/financial-tools-calculators/sbi-bank-sip-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Nippon Bank SIP Calculator  ",
    //   description:
    //     " Track your growth! Estimate potential gains from your Nippon Bank SIP.",
    //   link: "/financial-tools-calculators/nippon-bank-sip-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "LIC SIP Calculator  ",
    //   description:
    //     " Secure your savings! See how your LIC SIP can grow over time.",
    //   link: "/financial-tools-calculators/lic-bank-sip-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "PNB SIP Calculator    ",
    //   description:
    //     " Invest wisely! Use our calculator to project your PNB SIP returns.",
    //   link: "/financial-tools-calculators/pnb-bank-sip-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "IDBI SIP Calculator    ",
    //   description:
    //     " Plan ahead! Forecast your IDBI SIP returns in seconds.",
    //   link: "/financial-tools-calculators/idbi-bank-sip-calculator",
    // },
    {
      imgSrc: "../assets/7new.png",
      title: "Gold Loan EMI Calculator  ",
      description:
        " Pledge smartly! Estimate your EMIs on gold loans quickly and clearly.",
      link: "/financial-tools-calculators/gold-loan-emi-calculator",
    },
    {
      imgSrc: "../assets/8new.png",
      title: "Personal Loan EMI Calculator ",
      description:
        " Borrow with confidence! Plan your personal loan repayments with ease.",
      link: "/financial-tools-calculators/personal-loan-emi-calculator",
    },
    {
      imgSrc: "../assets/9new.png",
      title: "Business Loan EMI Calculator   ",
      description:
        "Power your business! Calculate EMIs to manage your business loan smartly.",
      link: "/financial-tools-calculators/business-loan-emi-calculator",
    },
    {
      imgSrc: "../assets/10new.png",
      title: "Education Loan EMI Calculator  ",
      description:
        " Fund your future! Estimate EMIs for your education loan and plan ahead.",
      link: "/financial-tools-calculators/education-loan-emi-calculator",
    },
    {
      imgSrc: "../assets/11new.png",
      title: "Two Wheeler Loan EMI Calculator  ",
      description:
        " Own your ride! Get a quick EMI breakdown for your two-wheeler loan.",
      link: "/financial-tools-calculators/two-wheeler-loan-emi-calculator",
    },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "SBI Car Loan EMI Calculator  ",
    //   description:
    //     " Drive your dream! Calculate EMIs for your SBI car loan in seconds.",
    //   link: "/financial-tools-calculators/sbi-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "AXIS Car Loan EMI Calculator  ",
    //   description:
    //     " Plan the ride! Get instant EMI estimates for your AXIS Bank car loan.",
    //   link: "/financial-tools-calculators/axis-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "ICICI Car Loan EMI Calculator  ",
    //   description:
    //     " Gear up smartly! Know your ICICI car loan EMIs with a quick check.",
    //   link: "/financial-tools-calculators/icici-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "HDFC Car Loan EMI Calculator  ",
    //   description:
    //     " Accelerate your plans! Estimate your HDFC car loan EMIs instantly.",
    //   link: "/financial-tools-calculators/hdfc-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Canara Car Loan EMI Calculator  ",
    //   description:
    //     " Own your drive! Calculate EMIs for your Canara Bank car loan with ease.",
    //   link: "/financial-tools-calculators/canara-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "PNB Car Loan EMI Calculator  ",
    //   description:
    //     " Cruise confidently! Plan your PNB car loan EMIs in just a few clicks.",
    //   link: "/financial-tools-calculators/pnb-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/unionbank.png",
    //   title: "UBI Car Loan EMI Calculator   ",
    //   description:
    //     " Steer ahead! Get your UBI car loan EMI breakdown effortlessly.",
    //   link: "/financial-tools-calculators/union-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "BOB Car Loan EMI Calculator  ",
    //   description:
    //     "  Hit the road! Estimate your car loan EMIs with Bank of Baroda in no time.",
    //   link: "/financial-tools-calculators/bank-of-baroda-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "BOM Car Loan EMI Calculator ",
    //   description:
    //     "  Fuel your drive! Calculate your Bank of Maharashtra car loan EMIs instantly.",
    //   link: "/financial-tools-calculators/bank-of-maharashtra-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Dhanlaxmi Bank Car Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/dhanlaxmi-bank-car-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "SBI Bank Bike Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/sbi-bank-bike-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "HDFC Bank Bike Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/hdfc-bank-bike-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "ICICI Bank Bike Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/icici-bank-bike-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Axis Bank Bike Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/axis-bank-bike-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Bajaj Finserv Bank Bike Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/bajaj-finserv-bank-bike-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Kotak Mahindra Bank Bike Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/Kotak-mahindra-bank-bike-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Tata Capital Bank Bike Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/tata-capital-bank-bike-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Mahindra Finance Bank Bike Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/mahindra-finance-bank-bike-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Muthoot Finance Bank Bike Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/muthoot-finance-bank-bike-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "SBI Home Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/sbi-home-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "HDFC Home Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/hdfc-home-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "ICICI Home Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/icici-home-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Axis Home Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/axis-home-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "Lic Housing Finance Home Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/lic-housing-finance-home-loan-emi-calculator",
    // },
    // {
    //   imgSrc: "../assets/tds.jpeg",
    //   title: "BOB Home Loan EMI Calculator  ",
    //   description:
    //     " Drive with ease! Get quick EMI insights for your Dhanlaxmi Bank car loan.",
    //   link: "/financial-tools-calculators/bob-home-loan-emi-calculator",
    // },
  ];

  return (
    <>
      <Helmet>
        <title>
        Free Financial Calculators & Tools – Plan Smartly with TheFinMaster
        </title>
        <meta
          name="description"
          content="Access a complete range of free financial calculators including SIP, EMI, Retirement, FD, PPF, and more to plan your finances smartly."
        />
        <meta
          name="keywords"
          content="financial calculator online, financial planning calculator, financial calculator online free"
        />
        <link
          rel="canonical"
          href="https://thefinmaster.com/financial-tools-calculators"
        />
        <meta
          name="robots"
          content="max-snippet:-1, max-image-preview:standard"
        />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      
      <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
        <ol className="list-none p-0 inline-flex">
          <li className="flex items-center">
            <Link to="/" className="text-blue-600 hover:text-blue-800 ">
              Home
            </Link>
            <svg
              className="w-4 h-4 mx-2 text-gray-500"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path
                fillRule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z"
                clipRule="evenodd"
              />
            </svg>
          </li>

          <li className="flex items-center">
            <span className="text-gray-500 ">Financial Tools Calculators</span>
          </li>
          {/* <li className="flex items-center">
          <Link to="/credit-card" className="text-blue-600 hover:text-blue-800">Credit Card</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li> */}
          {/* <li className="flex items-center">
          <span className="text-gray-500">Car Loan EMI Calculator</span>
        </li> */}
        </ol>
      </nav>
      <div className=" p-4 md:p-8 lg:p-10 mb-6 px-6 mx-4 md:mx-8 lg:mx-10 text-gray-600 flex justify-center items-center">
        <div>
          <h2 className="text-2xl md:text-xl lg:text-6xl text-center mb-4 text-gray-800">
            Financial Calculators
          </h2>
          <p className="text-lg md:text-base lg:text-2xl text-center">
            Use our Online financial calculators to make informed decisions about FDs,
            PPFs, EMIs, and more!
          </p>
          <p className="text-lg md:text-base lg:text-2xl text-center">
            Plan your savings with ease.
          </p>
        </div>
      </div>
      <div className="w-full px-4 md:px-8 lg:px-16 pb-8">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 gap-4 md:gap-6">
            {boxesData.map((box, index) => (
              <Box
                key={index}
                imgSrc={box.imgSrc}
                title={box.title}
                description={box.description}
                link={box.link}
              />
            ))}
          </div>
        </div>
      </div>
      
      {/* <div className="p-4 md:p-8 lg:p-8 mb-2 mx-4 md:mx-8 lg:mx-6 text-gray-600 flex justify-center items-center">
  <div>
    <h2 className="text-3xl md:text-4xl lg:text-4xl font-semibold text-gray-900 mb-6 text-center">
      Types of Financial Calculators
    </h2>
    <p className="text-lg md:text-base lg:text-xl text-center">
Digital banking today requires meticulousness, clarity, and quick decision-making. For the very same purpose, many different types of Financial Calculators exist to help individuals and businesses analyze financial aspects in an accurate manner. Here at Finmaster, we offer an extensive lineup of Online Financial Calculators for every relevant financial area-savings, loans, investments, tax planning, and retirement.    </p>
    <p className="text-lg md:text-base lg:text-xl text-center mt-2">
From EMI and SIP calculators to income tax, FD, RD, mortgage, and credit card payoff calculators, these tools give users a chance to have some peace of mind within minutes after solving a set of complicated calculations. Every Financial Calculator Online on our platform has been curated in such a way that it closely matches real banking standards and calculation conventions.
    </p>
  </div>
</div> */}
<section className="bg-gradient-to-b from-white to-gray-50 flex justify-center items-center text-gray-600 py-6 px-4 sm:px-6 md:px-10 lg:px-20">
      <div className="max-w-7xl w-full">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl lg:text-4xl font-semibold text-gray-900 mb-6 text-center">
          Types of Financial Calculators
        </h2>

        {/* Paragraph 1 */}
        <p className="text-base sm:text-lg md:text-xl text-center leading-relaxed mb-4">
Digital banking today requires meticulousness, clarity, and quick decision-making. For the very same purpose, many different types of Financial Calculators exist to help individuals and businesses analyze financial aspects in an accurate manner. Here at Finmaster, we offer an extensive lineup of Online Financial Calculators for every relevant financial area-savings, loans, investments, tax planning, and retirement.        </p>

        {/* Paragraph 2 */}
        <p className="text-base sm:text-lg md:text-xl text-center leading-relaxed">
From EMI and SIP calculators to income tax, FD, RD, mortgage, and credit card payoff calculators, these tools give users a chance to have some peace of mind within minutes after solving a set of complicated calculations. Every Financial Calculator Online on our platform has been curated in such a way that it closely matches real banking standards and calculation conventions.
        </p>
      </div>
    </section>
<section className="bg-gradient-to-b from-white to-gray-50 py-10 px-6 md:px-12 lg:px-24 text-gray-700">
      <div className="max-w-7xl mx-auto text-center">
        {/* Title */}
        <h2 className="text-3xl md:text-4xl lg:text-4xl font-semibold text-gray-900 mb-6">
          Benefits of Financial Calculator
        </h2>

        {/* Intro paragraph */}
        <p className="text-lg md:text-xl text-gray-600 leading-relaxed mb-10 max-w-4xl mx-auto">
With all this in mind, the financial calculators help to cultivate that all-important financial confidence based on rightly interpreted data. With the right Financial Calculators, users can:

        </p>
      </div>

      {/* Benefit List */}
      <div className="max-w-5xl mx-auto grid sm:grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8">
        {benefits.map((item, index) => (
          <div
            key={index}
            className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
          >
            <CheckCircle2 className="text-green-500 flex-shrink-0 mt-1" size={28} />
            <p className="text-base md:text-lg text-gray-700 leading-relaxed">{item}</p>
          </div>
        ))}
      </div>

      {/* Closing paragraph */}
      <div className="max-w-5xl mx-auto mt-14 text-center">
        <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
          Banking, wealth management, and private finance civil practitioners depend on these{" "}
          <span className="font-semibold text-gray-900">Online Financial Calculators</span> to
          serve as a reliable third, offering customers data-driven decisions.
        </p>
      </div>
    </section>
    <section className="bg-gradient-to-b from-white to-gray-50 flex justify-center items-center text-gray-600 py-6 px-4 sm:px-6 md:px-10 lg:px-20">
      <div className="max-w-7xl w-full">
        {/* Heading */}
        <h2 className="text-3xl md:text-4xl lg:text-4xl font-semibold text-gray-900 mb-6 text-center">
         Importance of Financial Calculators

        </h2>

        {/* Paragraph 1 */}
        <p className="text-base sm:text-lg md:text-xl text-center leading-relaxed mb-4">
For banking and financial planning audiences, having utmost accuracy and foresight cannot be compromised. Financial Calculators promote transparent financial planning. They assist the users in foreseeing the long-term effect of their choices regarding loans, investment, tax, saving, or retirement planning.
</p>
        {/* Paragraph 2 */}
        <p className="text-base sm:text-lg md:text-xl text-center leading-relaxed">
This freedom allows users to assess their finances on their own rather than simply assume. The resulting effect is an increase in financial literacy and providing a more structured path for budgeting, goal-based investing, and debt control. Therefore, in this digital age, a Financial Calculator Online holds the same significance equal to that of a bank passbook.
        </p>
      </div>
    </section>
    <section className="bg-gradient-to-b from-white to-gray-50 py-16 px-4 sm:px-6 md:px-10 lg:px-24 text-gray-700 flex justify-center items-center">
      <div className="max-w-5xl w-full">
        {/* Title */}
        <h2 className="text-3xl md:text-4xl lg:text-4xl font-semibold text-gray-900 mb-6 text-center">
          How can the Financial Calculators help you?
        </h2>

        {/* Description */}
        <p className="text-base sm:text-lg md:text-xl text-center leading-relaxed mb-10">
          These financial calculators become your personal financial adviser, be it home loan
          planning, retirement corpus setting, or systematic wealth growth. This is how they:
        </p>

        {/* Points */}
        <div className="grid sm:grid-cols-1 md:grid-cols-2 gap-6 lg:gap-8 max-w-4xl mx-auto">
          {points.map((item, index) => (
            <div
              key={index}
              className="flex items-start gap-4 bg-white p-6 rounded-2xl shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <CheckCircle2 className="text-green-500 flex-shrink-0 mt-1" size={28} />
              <p className="text-base sm:text-lg md:text-lg text-gray-700 leading-relaxed">{item}</p>
            </div>
          ))}
        </div>

        {/* Closing Paragraph */}
        <p className="text-base sm:text-lg md:text-xl text-center leading-relaxed mt-12 text-gray-600">
          Using the Online Financial Calculators helps individuals set financial goals accurately
          and, thus, lead with confidence.
        </p>
      </div>
    </section>
   
      {/* <div className="container mx-auto md:px-8 lg:px-8  px-4 sm:px-4  md:ml-4 lg:ml-4 sm:ml-0 ml-0">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 2xl:grid-cols-4 gap-4 ">
          {boxesData.map((box, index) => (
            <Box
              key={index}
              imgSrc={box.imgSrc}
              title={box.title}
              description={box.description}
              link={box.link}
            />
          ))}
        </div>
      </div> */}
    </>
  );
}

export default ToolsPages;
